import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../LangContext";

const PEN_IMG =
  "https://static.prod-images.emergentagent.com/jobs/b9279398-bca1-4726-a256-3cb06bf2f4ad/images/7d88cff1e073e0d3b3aecccab26d70b456e97a35a91c2bd5d2b6b76660a47aec.png";

const fade = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1], delay },
});

export default function Pricing() {
  const { t } = useLang();
  return (
    <section
      id="pricing"
      data-testid="pricing-section"
      className="py-24 md:py-32 bg-stone50"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-y-12 md:gap-x-12">
          <div className="col-span-12 md:col-span-5">
            <motion.p {...fade(0)} className="eyebrow text-ink2">
              — {t.pricing.eyebrow}
            </motion.p>
            <motion.h2
              {...fade(0.05)}
              className="headline mt-6 text-4xl sm:text-5xl lg:text-6xl text-ink"
              data-testid="pricing-title"
            >
              {t.pricing.title}
            </motion.h2>
            <motion.p
              {...fade(0.1)}
              className="mt-6 text-lg text-ink2 leading-relaxed max-w-md"
              data-testid="pricing-lede"
            >
              {t.pricing.lede}
            </motion.p>

            <motion.div
              {...fade(0.2)}
              className="mt-12 hidden md:block aspect-[4/3] overflow-hidden"
            >
              <img src={PEN_IMG} alt="" className="w-full h-full object-cover" />
            </motion.div>
          </div>

          <div className="col-span-12 md:col-span-6 md:col-start-7">
            <div className="space-y-12" data-testid="pricing-list">
              {t.pricing.sections.map((section, sIdx) => (
                <motion.div
                  key={section.heading}
                  {...fade(0.05 + sIdx * 0.08)}
                  data-testid={`pricing-section-${sIdx}`}
                >
                  <p className="eyebrow text-ink2 mb-4">{section.heading}</p>
                  <div className="border-t border-line">
                    {section.rows.map((r, i) => (
                      <div
                        key={r.t}
                        data-testid={`pricing-row-${sIdx}-${i}`}
                        className="flex items-baseline justify-between gap-4 border-b border-line py-4"
                      >
                        <span className="font-serif text-lg md:text-xl text-ink leading-snug">
                          {r.t}
                        </span>
                        <span className="text-sm md:text-base text-ink2 tabular-nums whitespace-nowrap">
                          {r.p}
                        </span>
                      </div>
                    ))}
                  </div>
                </motion.div>
              ))}
            </div>
            <motion.p
              {...fade(0.3)}
              className="mt-8 text-xs uppercase tracking-widest text-ink2 leading-relaxed"
              data-testid="pricing-footnote"
            >
              {t.pricing.footnote}
            </motion.p>
          </div>
        </div>
      </div>
    </section>
  );
}
